import { render, staticRenderFns } from "./NowhowRadioList.vue?vue&type=template&id=a8a29ce4"
import script from "./NowhowRadioList.vue?vue&type=script&lang=ts"
export * from "./NowhowRadioList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports